import React, { useState, useEffect } from 'react';
import trainTypes from '../TrainTypes';
import { Link } from 'react-router-dom';

export default function TrainInfo(props) {
	const [trainData, setTrainData] = useState();
	const [showError, setShowError] = useState(false);
	const { departureDate: stringDate, trainId } = props.match.params;
	useEffect(() => {
		fetch(`/api/GetTrainInfo?trainId=${trainId}&departureDate=${stringDate}`)
			.then(x => x.json())
			.then(setTrainData)
			.catch(e => alert(e));
	}, []);
	if (!trainData)
		return ("Пожалуйста, подождите...");
	const stationRows = trainData.stations.map(x => <tr>
		<td>{x.name}</td>
		<td>{x.arrivalTime}</td>
		<td>{x.hasStop ? 'Да' : 'Нет'}</td>
		<td>{x.departureTime}</td>
		<td>{x.distanceInKilometers}</td>
	</tr>);
	const printButton = () => {
		var mywindow = window.open('', 'PRINT', 'height=400,width=600');
		const element = document.getElementById("train-info");
		mywindow.document.write('<html><head></head><body>');
		mywindow.document.write(element.innerHTML);
		mywindow.document.write('</body></html>');
		mywindow.document.close(); // necessary for IE >= 10
		mywindow.focus(); // necessary for IE >= 10*/
		mywindow.print();
		mywindow.close();

		return true;
	}
	const returnButton = <Link to="/" className={"return-link"}>Назад</Link>;
	return (
		<React.Fragment>
			{returnButton}
			<div id="train-info">
				<h1 className="train-info__title">Расписание поезда</h1>
				<h2 className="train-info__data">{trainData.number}, {trainData.name} на {stringDate.replace(/-/g, '.')} г.</h2>
				<table className="train-info__table">
					<tbody>
						<tr><td>Перевозчик</td><td>ОА "Экспресс Приморья"</td></tr>
						<tr><td>Тип поезда </td><td>{trainTypes[trainData.trainType]}</td></tr>
						<tr><td>Дни следования</td><td>{trainData.period}</td></tr>
					</tbody>
				</table>
				<div className="info">
					<h1 className="info__warning">Время отправления и прибытия местное</h1>
				</div>
				<table className="train-info__stations-table">
					<thead>
						<th>Станция</th>
						<th>Время прибытия</th>
						<th>Стоянка</th>
						<th>Время отправления</th>
						<th>Расстояние, км</th>
					</thead>
					<tbody>
						{stationRows}
					</tbody>
				</table>
			</div>
			{returnButton}
			<a onClick={printButton} className={"train-info__print-button"}>Распечатать</a>
		</React.Fragment>
	);
}